export default __webpack_public_path__ + "static/media/685.5fae0ccf.png";